import store from "../../store";

export default class QuizCreateRequest {
    constructor(supportedLocales) {
        this.difficultyLevel = null;
        this.type =  {
            enumValue : store.getState().quizForUserActionEnabled ? 'SURVEY' : 'STANDARD',
            label : store.getState().quizForUserActionEnabled ? 'Ankieta' :  'Quiz'
          };
        this.eduDuration = 15;
        this.quizDuration = 15;
        this.availabilityInStatistics = undefined;
        this.iconTemporaryFileUrl = '';
        this.translations = [];
        this.publicResults = false;
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                subject: '',
                description: '',
                quizIntroduction: '',
                questions: [],
                eduMaterials: [],
                activeFrom: null,
                activeTo: null,
            };
        });
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
            to.title = from.title;
        } else {
            to = new QuizCreateRequest();
        }
    }

    static copy(from) {
        const to = new QuizCreateRequest();
        QuizCreateRequest.assign(from, to);
        return to;
    }
}
